export * from './elements/index.js';
// Lib loader is public API: CSP-locked hosts pre-register bundled modules
// (e.g. xterm) through provideXtermModules instead of the CDN path.
export * from './services/index.js';
import * as colors from './elements/00colors.js';
export { colors };
export { commitinfo } from './00_commitinfo_data.js';
